// Add multiple nature descriptions for different images
export const abstractdescriptions = Array.from({ length: 1000 }, () => `Corporate Series`);

const abstractcontext = Array(1000).fill("Wallpapers elevate professional environments by reinforcing brand identity, boosting employee morale, and creating a lasting impression on clients through thoughtful and impactful design.");

// Base AWS S3 URL
const AWS_BASE_URL = "https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/Corporate";

// Function to get image URL with fallback between .jpeg and .jpg
const getImageUrl = (imageNumber) => {
    const jpegUrl = `${AWS_BASE_URL}/(${imageNumber}).jpeg`;
    const jpgUrl = `${AWS_BASE_URL}/(${imageNumber}).jpg`;

    // Return an object with both URLs for the component to handle
    return {
        jpeg: jpegUrl,
        jpg: jpgUrl
    };
};

// Seeded random generator (Mulberry32)
function mulberry32(seed) {
    return function () {
        let t = (seed += 0x6D2B79F5);
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}

// Deterministic shuffle using seed
function seededShuffle(array, seed = 123456) {
    const rng = mulberry32(seed);
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(rng() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
}

// Generate wall data
const generateWalldata = () =>
    Array.from({ length: 276 }, (_, index) => {
        const imgNum = index + 1;
        const imageUrls = getImageUrl(imgNum);

        return {
            Img: imageUrls.jpeg, // Default to jpeg, component will handle fallback
            ImgJpg: imageUrls.jpg, // Backup jpg URL
            title: `#CR${String(imgNum).padStart(3, '0')}`,
            desc: abstractdescriptions[index] || "Default description",
            context: abstractcontext[index] || "Default context",
            btn: 'View Detail',
        };
    });

// Shuffle the data with a fixed seed
export const walldata = seededShuffle(generateWalldata(), 42);